<template>
  <div>
    <b-button v-b-modal.modal-prevent-closing-registrator
      >Створити адміна</b-button
    >
    <b-modal
      id="modal-prevent-closing-registrator"
      ref="modal"
      title="Створення адміну"
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleOk"
      centered
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group
          label="Електронна пошта"
          label-for="email-input"
          invalid-feedback="Введіть електронну пошту!"
          :state="modalState"
        >
          <b-form-input type="email" v-model="admin.username"></b-form-input>
        </b-form-group>
        <b-form-group
          label="Пароль"
          label-for="password-input"
          invalid-feedback="Заповніть пароль!"
          :state="modalState"
        >
          <b-form-input type="password" v-model="admin.password"></b-form-input>
        </b-form-group>
      </form>
    </b-modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";

var axios = require("axios");
export default {
  name: "AdminCreator",
  data: function () {
    return {
      admin: {
        username: null,
        password: null,
      },
      modalState: null,
    };
  },
  methods: {
    ...mapActions(["logOutUser"]),
    resetModal() {
      for (let field in this.admin) {
        this.admin[`${field}`] = null;
      }
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      this.handleSubmit();
    },
    async handleSubmit() {
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${this.$cookie.get("access_token")}`,
        },
      };
      let fd = new FormData();
      fd.append("username", this.admin.username);
      fd.append("password", this.admin.password);
      fd.append("club_id", 1);
      await axios
        .post(`${process.env.VUE_APP_API}/admin/register`, fd, config)
        .catch((err) => {
          if (err.response.status === 401) {
            this.logOutUser();
          }
        });
      this.$emit("refresh");
      this.$nextTick(() => {
        this.$bvModal.hide("modal-prevent-closing-registrator");
      });
    },
  },
};
</script>

<style scoped></style>
